export const WhatsAppButton = ({phoneNumber}) => {
  const message = "Hola, me gustaría más información.";
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-button"
    >
      <i className="fa fa-brands fa-whatsapp"></i>
    </a>
  );
};
